import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LOGO } from "src/assets/image";
import MenuGlobal from "../MenuGlobal";
import MobileMenuGlobal from "../MobileMenuGlobal";
import "./style.css";

const HeaderGlobal = () => {
  return (
    <header id="masthead" className="header ttm-header-style-01">
      <div className="ttm-topbar-wrapper ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
        <div className="container-xl">
          <div className="row">
            <div className="col-lg-5">
              <ul className="top-contact text-left">
                <li>
                  <i className="fas fa-map-marker-alt" />
                  &nbsp;&nbsp;Kabupaten Sigi 94364
                </li>
                <li>
                  <i className="far fa-envelope" />
                  &nbsp;&nbsp;
                  <a to="mailto:info@satudata.sigikab.go.id">
                    info@satudata.sigikab.go.id
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-7">
              <div className="topbar-right text-right d-flex justify-content-end">
                <ul className="top-contact"></ul>
                <div className="ttm-social-links-wrapper list-inline">
                  <ul className="social-icons">
                    <li>
                      <a
                        href="https://www.facebook.com/profile.php?id=100015120135658"
                        className=" tooltip-bottom"
                        data-tooltip="Facebook"
                      >
                        <i className="fab fa-facebook" />
                      </a>
                    </li>
                    {/* <li><a href="https://instagram.com/dinkominfomuba?utm_medium=copy_link" className=" tooltip-bottom" data-tooltip="Youtube"><i className="fab fa-youtube" /></ a>
                                        </li> */}
                    <li>
                      <a
                        href="https://www.instagram.com/diskominfokabupatensigi/"
                        className=" tooltip-bottom"
                        data-tooltip="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="header-btn">
                  <a
                    className="ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor"
                    href="http://sigiadm.swg.co.id"
                    target={"_blank"}
                  >
                    <i className="fa fa-user" /> Masuk
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ttm-header-wrap">
        <div id="navbar" className="ttm-stickable-header clearfix">
          <div className="site-header-menu">
            <div className="container-xl">
              <div className="site-branding">
                <Link
                  className="home-link"
                  to={process.env.PUBLIC_URL + "/"}
                  title="SATU DATA"
                  rel="home"
                >
                  <img
                    id="logo-img"
                    className="img-fluid"
                    alt="logo"
                    src={LOGO}
                  />
                </Link>
              </div>
              <div className="site-navigation">
                <div className="ttm-right-header">
                  <ul className="ttm-header-icons"></ul>
                </div>
                <MenuGlobal />
                <div className="mobilemenu">
                  <MobileMenuGlobal />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderGlobal;
